import styled from "styled-components";

const Container = styled.div`
  width: 100%;

  .isAmBy li.list-component-child:nth-child(odd){
    background-color: transparent;

    &:hover{
      box-shadow: none;
    }
  }
`;

export default Container;
